<template>
  <div id="app">
    <router-view />
    <site-float v-if="isHome" />
  </div>
</template>

<script>
import SiteFloat from '@/components/SiteFloat.vue'

export default {
  name: 'App',
  components: {
    SiteFloat
  },
  computed: {
    /** 电话、留言、顶部只在首页显示 */
    isHome() {
      const name = this.$route.name
      return name === 'Home' || name === 'HomeEn'
    }
  }
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  min-height: 100%;
}
body {
  background: #fff;
}
/* 禁止鼠标拖动图片 */
img {
  -webkit-user-drag: none;
  user-select: none;
}
</style>
